import React, { Component } from 'react'
import { connect } from 'react-redux'

import { FILE_STORAGE } from '../../../constants'

// actions
import { saveEmbeddedBooking } from '../../../actions/embeddedbooking'
import { createFileContainer, uploadMultipleFiles } from '../../../actions/orders'

// Components
import Dropzone from '../../../shared/components/Dropzone'
import Gallery from '../../../shared/components/Gallery'
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'

// Elements
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Button from '../../../shared/elements/button'
import RemoveButton from '../../../shared/elements/removeButton'

// utils
import { translation } from '../../../utils/helpers'

// Icons
import { EmbeddedBookingIcons } from '../../../shared/elements/icons'
import Icon from '../../../shared/elements/icon'

// styles
import './uploadphotoview.scss'
import LicensePlate from '../../../shared/components/LicensePlate'

class UploadPhotoView extends Component {
  constructor (props) {
    super(props)
    this.state = {
      upload: {
        loading: false,
        errors: []
      },
      errors: [],
      confirm: {
        open: false
      }
    }
    this.onDrop = this.onDrop.bind(this)
    this.onDropAccepted = this.onDropAccepted.bind(this)
    this.renderImage = this.renderImage.bind(this)
    this.renderPhotoGuide = this.renderPhotoGuide.bind(this)
    this.ensureFileContainer = this.ensureFileContainer.bind(this)
    this.deleteFile = this.deleteFile.bind(this)
    this.onPortalClose = this.onPortalClose.bind(this)
    this.onConfirm = this.onConfirm.bind(this)
  }

  // componentDidMount () {
  //   this.setState({
  //     files: this.props.embeddedbooking.
  //   })
  // }

  ensureFileContainer () {
    if (this.props.embeddedbooking.FilesInfo.FileContainerId === null) {
      return this.props.createFileContainer().then((res) => {
        return this.props.saveEmbeddedBooking({ FilesInfo: { FileContainerId: res.data.FileContainerId } })
        // this.setState({
        //   fileContainerId: res.data.FileContainerId
        // })
      })
    } else {
      return Promise.resolve()
    }
  }

  onDrop () {
    this.setState({ upload: { ...this.state.upload, errors: [] } })
  }

  onDropAccepted (files) {
    this.ensureFileContainer().then(() => {
      this.setState({
        upload: {
          ...this.state.upload,
          files: files,
          loading: true
        }
      }, () => {
        let type = 0
        this.props.uploadMultipleFiles(this.state.upload.files, 0, type, null, this.props.embeddedbooking.FilesInfo.FileContainerId).then(res => {
          // Get updated booking details.
          this.props.saveEmbeddedBooking({ CurrentStep: 2 })
          this.setState({ upload: { ...this.state.upload, files: [], loading: false } })
        })
      })
    })
  }

  onDropRejected (files) {
    let newErrors = []
    files.map((file) => {
      newErrors.push(translation('1207') + ': ' + file.name + ' ' + translation('13405') + '.')
    })
    this.setState({ upload: { ...this.state.upload, errors: newErrors, files: [] } })
  }

  deleteFile (fileId) {
    this.props.saveEmbeddedBooking({
      CurrentStep: 2,
      FilesInfo: { DeleteFileId: fileId }
    })
  }

  renderImage (image, index) {
    const url = FILE_STORAGE + image.ThumbURL
    const fullUrl = FILE_STORAGE + image.FileURL
    return (
      <div className='image-div' key={index}>
        <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
        <RemoveButton size='s' onClick={() => this.deleteFile(image.OrderFileID)} />
      </div>
    )
  }

  renderPhotoGuide (flowType) {
    var reg = flowType === 'with_regnr'

    if (!reg) {
      return (
        <div className='photo_guide'>
          <div className='row'>
            <div className='guideImageWrapper'>
              <img src={EmbeddedBookingIcons.Photo_Guide_2.fileName} />
              <span>{translation(16693)}</span>
            </div>
            <div className='guideImageWrapper'>
              <img src={EmbeddedBookingIcons.Photo_Guide_3.fileName} />
              <span>{translation(16714)}</span>
            </div>
          </div>
          <div className='row'>
            <div className='guideImageWrapper'>
              <img src={EmbeddedBookingIcons.Photo_Guide_4.fileName} />
              <span>{translation(18320)}</span>
            </div>
            <div className='guideImageWrapper'>
              <img src={EmbeddedBookingIcons.Photo_Guide_5.fileName} />
              <span>{translation(16716)}</span>
            </div>
          </div>
          <div className='row'>
            <div className='guideImageWrapper'>
              <img src={EmbeddedBookingIcons.Photo_Guide_6.fileName} />
              <span>{translation(16717)}</span>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className='photo_guide'>
        <div className='row'>
          <div className='guideImageWrapper'>
            {this.props.embeddedbooking.CarData.RegNumber !== null && (
              <div className='ghost'>
                <LicensePlate regNr={this.props.embeddedbooking.CarData.RegNumber} countryCode={this.props.countryCode} />
              </div>
            )}
            {this.props.embeddedbooking.CarData.RegNumber !== null && (
              <img src={EmbeddedBookingIcons.Photo_Guide_1.fileName} />
            )}
            {this.props.embeddedbooking.CarData.RegNumber !== null && (
              <span>{translation(16577)}</span>
            )}
          </div>
          <div className='guideImageWrapper'>
            <img src={EmbeddedBookingIcons.Photo_Guide_2.fileName} />
            <span>{translation(16693)}</span>
          </div>
        </div>
        <div className='row'>
          <div className='guideImageWrapper'>
            <img src={EmbeddedBookingIcons.Photo_Guide_3.fileName} />
            <span>{translation(16714)}</span>
          </div>
          <div className='guideImageWrapper'>
            <img src={EmbeddedBookingIcons.Photo_Guide_4.fileName} />
            <span>{translation(18320)}</span>
          </div>
        </div>
        <div className='row'>
          <div className='guideImageWrapper'>
            <img src={EmbeddedBookingIcons.Photo_Guide_5.fileName} />
            <span>{translation(16716)}</span>
          </div>
          <div className='guideImageWrapper'>
            <img src={EmbeddedBookingIcons.Photo_Guide_6.fileName} />
            <span>{translation(16717)}</span>
          </div>
        </div>
      </div>
    )
  }

  onPortalClose () {
    this.setState({
      confirm: {
        ...this.state.confirm,
        open: false
      }
    })
  }

  render () {
    let { errors } = this.state.upload
    let images = this.props.embeddedbooking.FilesInfo.Files.filter(x => x.IsImage)
    let leftChildren = true

    const renderError = (error, index) => {
      return <p key={index}>{error}</p>
    }

    const openPortal = () => {
      this.setState({
        confirm: {
          open: true
        }
      })
    }

    return (
      <div className='upload-photo__view'>
        <article className='main'>
          {this.props.children}
          <h1>{translation(16697)}</h1>
          <LabelWrapper labelText=''>
            {errors.length !== 0 && <div className='alert alert-danger'>{errors.map(renderError)}</div>}
            <Dropzone
              onDrop={this.onDrop}
              onDropAccepted={this.onDropAccepted}
              onDropRejected={this.onDropRejected}
              includeCircles={false}>
              {this.state.upload.loading && (
                <p className='loading'>
                  <span className='animated-background'>
                    <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
                    <span className='sr-only'>{translation('13382')}...</span>
                  </span>
                </p>
              )}
              {!this.state.upload.loading && (
                <div className='imageWrapper'>
                  <img src={EmbeddedBookingIcons.Upload_Image.fileName} />
                  <span>{translation(18439)}</span>
                </div>
              )}
            </Dropzone>
          </LabelWrapper>
          <div className='upload-photo__view--inner'>
            <div className='clearfix'>
              <Gallery files={images} renderImage={this.renderImage} />
            </div>
          </div>
          <div className='ctaWrapper'>
            <Button style='secondary' labelText={translation('394')} onClick={(e) => this.props.onNavClick(e, 'previous')} leftChildren={leftChildren}>
              <Icon
                size='s'
                icon={EmbeddedBookingIcons.Left_Arrow}
                injectSvg
              />
            </Button>
            <Button style='primary' labelText={translation(237)} onClick={openPortal}>
              <Icon
                size='s'
                icon={EmbeddedBookingIcons.Right_Arrow}
                injectSvg
              />
            </Button>
          </div>
        </article>
        <aside className='side'>
          <section>
            <h1>{translation(18432)}</h1>
            <p>{translation(16722)}</p>
          </section>
          <section>
            {this.renderPhotoGuide(this.props.flowType)}
          </section>
        </aside>
        {this.state.confirm.open && (
          <Portal className='confirm_popup embeddedBooking' onPortalClose={this.onPortalClose}>
            <Confirm confirm={this.onConfirm} notConfirm={this.onPortalClose} renderText={this.renderText} cancelStyle='link' actionStyle='cta' />
          </Portal>
        )}
      </div>
    )
  }

  renderText () {
    return (
      <div>
        {translation('16844')}
      </div>
    )
  }

  onConfirm (e) {
    this.onPortalClose()
    this.props.onNavClick(e, 'next')
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    embeddedbooking: state.embeddedbooking
  }
}

export default connect(mapStateToProps, {
  saveEmbeddedBooking,
  createFileContainer,
  uploadMultipleFiles
})(UploadPhotoView)



// WEBPACK FOOTER //
// ./src/app/pages/EmbeddedBooking/UploadPhotoView/index.js